import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

/*
 * Component to display a score with stars
 * @param score - The score to be displayed
 */
@Component({
  selector: 'app-score',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './score.component.html',
  styleUrls: ['./score.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScoreComponent implements OnInit {
  /*
   * The score to be displayed as stars (0 to 5)
   */
  @Input() score = 0;

  /*
   * Array of icons to be displayed for each star
   */
  stars: string[] = [];

  ngOnInit(): void {
    this.buildStars();
  }

  /*
   * Returns the icon to be displayed for each star
   * @param position - The position of the star
   * @returns The icon to be displayed for the star
   */
  protected getStarIcon(position: number): string {
    const integerPart = Math.floor(this.score);
    const decimalPart = this.score - integerPart;
    if (position <= integerPart) {
      return 'star';
    } else if (position === integerPart + 1) {
      if (decimalPart > 0 && decimalPart < 0.5) {
        return 'star_half';
      } else if (decimalPart >= 0.5) {
        return 'star';
      }
    }
    return 'star_border';
  }

  /*
   * Builds the stars array to be displayed
   */
  buildStars(): void {
    this.stars = Array.from({ length: 5 }, (_, i) => this.getStarIcon(i + 1));
  }
}
